import { useEffect, useState } from 'react'
import { useProjectPlanSnapshotRepository } from '../../../../services/adaptors/projectPlanSnapshotRepositoryAdaptor'
import { useProjectPrivateContext } from '../../../context/projectContext'
import { fetchTicketListSelectRows } from '../lib/snapshotRows'

const EMPTY_ICON_URLS: ReadonlyMap<string, string> = new Map()

/**
 * チケット管理表ごとの、チケット種別のアイコン。チケット別進捗状況の名称の横に出す。
 * 管理表の一覧はスナップショット単位でキャッシュされるので、設定画面と同じ取得を繰り返さない。
 */
export const useTicketListIconUrls = (
  snapshotUuid: string,
  isEnabled: boolean
): ReadonlyMap<string, string> => {
  const { fetchMasterScheduleTicketLists } = useProjectPlanSnapshotRepository()
  const { ticketTypes } = useProjectPrivateContext()
  const [iconUrls, setIconUrls] =
    useState<ReadonlyMap<string, string>>(EMPTY_ICON_URLS)

  useEffect(() => {
    if (!isEnabled) return
    let isCancelled = false
    fetchTicketListSelectRows(snapshotUuid, fetchMasterScheduleTicketLists)
      .then(rows => {
        if (isCancelled) return
        setIconUrls(
          new Map(
            rows.flatMap(row => {
              const iconUrl = ticketTypes.find(
                type => type.code === row.ticketType
              )?.iconUrl
              return iconUrl ? [[row.uuid, iconUrl] as const] : []
            })
          )
        )
      })
      // アイコンが出ないだけで表は使えるので、通知は共通 API クライアントに任せる
      .catch(error => console.error('Failed to fetch ticket lists:', error))
    return () => {
      isCancelled = true
    }
  }, [isEnabled, snapshotUuid, fetchMasterScheduleTicketLists, ticketTypes])

  return iconUrls
}
